import React from "react";

import { Box, CircularProgress, Typography } from "@mui/material";
import type { AICardConfig, AICardData, CardData } from "store/types";

interface Props {
  config: AICardConfig;
  data?: CardData;
  loading?: boolean;
}

export const AICard: React.FC<Props> = ({ config, data, loading }) => {
  const aiData = data as AICardData | undefined;
  const answer = aiData?.answer ?? config.answer;
  return (
    <Box sx={{ p: "16px 20px" }}>
      {config.question && (
        <Typography
          sx={{
            fontSize: 14,
            fontWeight: 600,
            color: "#111827",
            mb: 1.5
          }}
        >
          {config.question}
        </Typography>
      )}
      {loading ? (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <CircularProgress size={16} sx={{ color: "#6B7280" }} />
          <Typography sx={{ fontSize: 12, color: "#9CA3AF" }}>Getting answer...</Typography>
        </Box>
) : answer && config.question ? (
        <Box
          sx={{
            bgcolor: "#F9FAFB",
            borderRadius: "8px",
            p: "12px 16px",
            border: "1px solid #E5E7EB"
          }}
          component="div"
          dangerouslySetInnerHTML={{ __html: answer }}
        />
      ) : (
        <Typography sx={{ fontSize: 12, color: "#9CA3AF", fontStyle: "italic" }}>
          No answer yet. Click the card and ask a question in the settings panel.
        </Typography>
      )}
    </Box>
  );
};
